import { ContactCornSchema } from '@eigtech/contacts-types';
import { z } from 'zod';
import { GuidedDocumentTemplateSchema } from '../base/guidedDocument.js';
export const ListGuidedDocumentTemplatesQuerySchema = z.object({
    carrierContactCorn: ContactCornSchema.optional(),
});
export const ListGuidedDocumentTemplatesRequestSchema = ListGuidedDocumentTemplatesQuerySchema;
export const ListGuidedDocumentTemplatesApiSchema = {
    query: ListGuidedDocumentTemplatesQuerySchema,
    response: GuidedDocumentTemplateSchema.array(),
};
